export const EWorkerInformationSection = {
  ACCOUNT_INFO: "account_info",
  BANK_INFO: "bank_info",
  CUSTOM_PAPERWORK: "paperwork",
  INSTANT_PAY: "instant_pay",
  PAYCARD: "paycard",
  PAYCARD_SSN_ID_VERIFICATION: "paycard_ssn_id_verification",
  PAYCARD_SSN_SSC_VERIFICATION: "paycard_ssn_ssc_verification",
  PROFILE_INFO: "profile_info",
  SURVEY: "survey",
  TRANSACTION: "transaction",
} as const;

export type TWorkerInformationSection =
  (typeof EWorkerInformationSection)[keyof typeof EWorkerInformationSection];

export const contractorShareableLinkSections: TWorkerInformationSection[] = [
  EWorkerInformationSection.BANK_INFO,
  EWorkerInformationSection.CUSTOM_PAPERWORK,
  EWorkerInformationSection.INSTANT_PAY,
  EWorkerInformationSection.PAYCARD,
  EWorkerInformationSection.PAYCARD_SSN_ID_VERIFICATION,
  EWorkerInformationSection.PAYCARD_SSN_SSC_VERIFICATION,
  EWorkerInformationSection.TRANSACTION,
];
